(function () {

    'use strict';

    angular.module('bowser', [])
        .provider('bowser', BowserProvider);

    BowserProvider.$inject = [
        '$windowProvider'
    ];
    function BowserProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.bowser || {};
            }
        };
    }
})();
